import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { MapPin, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export const FarmCard = ({ farm, className }) => {
  return (
    <Card className={cn("overflow-hidden card-hover", className)}>
      {/* Image */}
      <div className="aspect-[16/10] overflow-hidden">
        <img
          src={farm.heroImage}
          alt={farm.name}
          className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
        />
      </div>

      {/* Content */}
      <div className="p-6">
        <div className="flex items-center gap-1.5 text-sm text-muted-foreground mb-2">
          <MapPin className="h-4 w-4" />
          <span>{farm.location}</span>
        </div>

        <h3 className="font-display text-xl font-semibold text-foreground">
          {farm.name}
        </h3>

        <p className="text-sm text-muted-foreground mt-2 line-clamp-2">
          {farm.storyShort}
        </p>

        <blockquote className="mt-4 text-sm italic text-muted-foreground border-l-2 border-primary/30 pl-4">
          "{farm.farmerQuote.slice(0, 100)}..."
        </blockquote>

        <Button asChild variant="link" className="p-0 h-auto mt-4 gap-1">
          <Link to={`/farm-stories/${farm.id}`}>
            Read their story
            <ArrowRight className="h-4 w-4" />
          </Link>
        </Button>
      </div>
    </Card>
  );
};
